import { useSelector } from 'react-redux'
import AssessmentSummary from './AssessmentSummary'
import SurveyCompletion from './SurveyCompletion'
import AssessmentByMonth from './AssessmentByMonth'
import RoundProgress from './RoundProgress'

const isMaestroRole = (roles = []) => roles.some((r) => r?.id === 'Maestro')

const BiDashboard = () => {
  const userRoles = useSelector((state) => state?.session?.user?.roles || [])
  const isMaestro = isMaestroRole(userRoles)

  if (!isMaestro) return null

  return (
    <div>
      <div
        style={{
          padding: '4px 24px',
          fontSize: 11,
          color: '#888',
          fontWeight: 600,
          letterSpacing: 1,
          textTransform: 'uppercase'
        }}
      >
        Internal — Maestro only
      </div>
      <SurveyCompletion />
      <AssessmentSummary />
      <AssessmentByMonth />
      <RoundProgress />
    </div>
  )
}

export default BiDashboard
